<template lang="html">
  <section class="app-header p-3 mb-2 d-flex">
    <div class="bg-white rounded-circle text-center d-flex justify-content-center">
      <img src="../../assets/logo.png" alt="" class="img-fluid logo align-self-center">
    </div>
    <h1 class="align-self-center text-white">ADMINISTRATION PANEL</h1>
  </section>
</template>

<script lang="js">
export default {
  name: 'Header',
  props: [],
  mounted () {},
  data () {
    return {}
  },
  methods: {},
  computed: {}
}
</script>

<style scoped lang="scss">
  section.app-header {
    position: fixed;
    top: 0;
    width: 100%;
    background-color: var(--dark-color);
  }
  div{
    width: 120px;
    height: 120px;
  }
  .logo{
    width: 80px;
  }
  h1{
    margin-left: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/Header.vue